import { useUser } from '~/api/user';
import { AlertDialog } from '~/components';

export const useConfirmExtraIntegration = () => {
  const { data: user } = useUser();
  const handle = AlertDialog.useHandle<() => void>();

  const confirm = (action: () => void) => {
    if (user.peppol.id === null) {
      action();
    } else {
      handle.openWithPayload(action);
    }
  };

  return { confirm, handle };
};
